<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import { EndPointMarker, StartPointMarker } from "@/constants/markers";

const { t } = useI18n();

type LegendMarker = google.maps.Symbol & { path: string; fillColor: string; strokeColor: string };

const startMarker = StartPointMarker as LegendMarker;
const endMarker = EndPointMarker as LegendMarker;
</script>

<template>
  <div class="order-map-legend">
    <div class="d-flex align-center order-map-legend__row">
      <div class="order-map-legend__icon">
        <svg height="30" viewBox="0 0 18 24" width="24">
          <path
            :d="startMarker.path"
            :fill="startMarker.fillColor"
            :stroke="startMarker.strokeColor"
            stroke-width="1"
          />
        </svg>
      </div>
      <span class="font-weight-500 ml-3 text-grey-darken-2">{{ t("orders.stop.pick-up") }}</span>
    </div>

    <div class="d-flex align-center mt-5 order-map-legend__row">
      <div class="order-map-legend__icon">
        <svg height="30" viewBox="0 0 18 24" width="24">
          <path :d="endMarker.path" :fill="endMarker.fillColor" :stroke="endMarker.strokeColor" stroke-width="1" />
        </svg>
      </div>
      <span class="font-weight-500 ml-3 text-grey-darken-2">{{ t("orders.stop.delivery") }}</span>
    </div>

    <div class="d-flex align-center mt-5 order-map-legend__row order-map-legend__order--route">
      <div class="order-map-legend__icon order-map-legend__icon--route"></div>
      <span class="font-weight-500 ml-3 text-grey-darken-2">{{ t("maps.order-route") }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/color";

.order-map-legend {
  margin-top: 20px;

  &__icon {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 26px;
  }

  &__order--route {
    transform: translateX(4px);
  }

  &__icon--route {
    width: 30px;
    height: 7px;
    background-color: $green;
    border-radius: 8px;
  }
}
</style>
